export default function getBTURL(rootURL) {
 if (rootURL.includes('.qa.')) {
  return 'www.stage.brighttalk.net';
 } else if (rootURL.includes('.eng.')) {
  return 'www.test01.brighttalk.net';
 } else {
  return 'www.brighttalk.com';
 }
}
